import { useState, useEffect } from 'react';
import { rememberAcquisition } from './lib/acquisition';
import '@/App.css';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from 'sonner';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import LandingPage from './pages/LandingPage';
import Registro from './pages/Registro';
import Login from './pages/Login';
import { RecuperarContrasena, RestablecerContrasena } from './pages/RecuperarContrasena';
import Simulador from './pages/Simulador';
import Cotizador from './pages/Cotizador';
import CotizacionFormal from './pages/CotizacionFormal';
import CotizadorOficio from './pages/CotizadorOficio';
import OficioUSA from './pages/OficioUSA';
import CuantoCobrar from './pages/CuantoCobrar';
import MensajesWhatsApp from './pages/MensajesWhatsApp';
import LandingUSA from './pages/LandingUSA';
import Precios from './pages/Precios';
import PagoExitoso from './pages/PagoExitoso';
import Dashboard from './pages/Dashboard';
import Cotizaciones from './pages/Cotizaciones';
import Productos from './pages/Productos';
import Clientes from './pages/Clientes';
import Conversaciones from './pages/Conversaciones';
import CargaProductos from './pages/CargaProductos';
import ConfiguracionWhatsApp from './pages/ConfiguracionWhatsApp';
import ConfigCobros from './pages/ConfigCobros';
import PerfilEmpresa from './pages/PerfilEmpresa';
import PortalCliente from './pages/PortalCliente';
import AdminPromoCodes from './pages/AdminPromoCodes';
import AdminDashboard from './pages/AdminDashboard';
import AdminTwilio from './pages/AdminTwilio';
import AdminSearchStats from './pages/AdminSearchStats';
import AdminSEO from './pages/AdminSEO';
import Onboarding from './pages/Onboarding';
// Páginas SEO
import DemoPage from './pages/DemoPage';
import FerreteriasSEO from './pages/FerreteriasSEO';
import RefaccionariasSEO from './pages/RefaccionariasSEO';
import ServiciosTecnicosSEO from './pages/ServiciosTecnicosSEO';
import PrivacidadPage from './pages/PrivacidadPage';
import TerminosPage from './pages/TerminosPage';
import Calculadoras from './pages/Calculadoras';
import Contacto from './pages/Contacto';
import Afiliados from './pages/Afiliados';
import GiroSEO from './pages/GiroSEO';
import Blog from './pages/Blog';
import CalculadoraIVA from './pages/CalculadoraIVA';
import PlantillasCotizacion from './pages/PlantillasCotizacion';
import GeneradorCotizaciones from './pages/GeneradorCotizaciones';
import BlogPost from './pages/BlogPost';
import { Menu, X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AppRoutes() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout, isAuthenticated } = useAuth();
  const location = useLocation();
  useEffect(() => { rememberAcquisition(location.search); }, [location.search]);
  const isOnboarding = location.pathname.startsWith('/onboarding');

  return (
    <>
        {/* Header - Solo mostrar en rutas autenticadas (no en onboarding) */}
        {isAuthenticated && !isOnboarding && (
          <header className="bg-white border-b border-slate-200 sticky top-0 z-50" data-testid="main-header">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex justify-between items-center h-16">
                <Link 
                  to="/dashboard" 
                  className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity" 
                  data-testid="header-logo-link"
                  onClick={() => setActiveTab('dashboard')}
                >
                  <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center text-xl shadow-md shadow-emerald-200">🤖</div>
                  <div className="pointer-events-none">
                    <h1 className="text-lg font-extrabold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">CotizaBot</h1>
                    <p className="text-xs text-slate-400">{user?.empresa?.nombre || user?.usuario?.empresa_nombre}</p>
                  </div>
                </Link>

                <nav className="hidden md:flex items-center gap-1">
                  <Link
                    to="/dashboard"
                    data-testid="nav-dashboard"
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      activeTab === 'dashboard'
                        ? 'bg-emerald-50 text-emerald-700'
                        : 'text-slate-600 hover:bg-slate-100'
                    }`}
                    onClick={() => setActiveTab('dashboard')}
                  >
                    Inicio
                  </Link>
                                    <Link
                    to="/productos"
                    data-testid="nav-productos"
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      activeTab === 'productos'
                        ? 'bg-emerald-50 text-emerald-700'
                        : 'text-slate-600 hover:bg-slate-100'
                    }`}
                    onClick={() => setActiveTab('productos')}
                  >
                    Productos
                  </Link>
                                                      <Link
                    to="/cotizador"
                    data-testid="nav-cotizador"
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      activeTab === 'cotizador'
                        ? 'bg-emerald-50 text-emerald-700'
                        : 'text-slate-600 hover:bg-slate-100'
                    }`}
                    onClick={() => setActiveTab('cotizador')}
                  >
                    ✨ Cotizador
                  </Link>
                  <Link
                    to="/simulador"
                    data-testid="nav-simulador"
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      activeTab === 'simulador'
                        ? 'bg-emerald-50 text-emerald-700'
                        : 'text-slate-600 hover:bg-slate-100'
                    }`}
                    onClick={() => setActiveTab('simulador')}
                  >
                    🧪 Probar mi bot
                  </Link>
                  <Link
                    to="/configuracion-whatsapp"
                    data-testid="nav-whatsapp"
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      activeTab === 'whatsapp'
                        ? 'bg-emerald-50 text-emerald-700'
                        : 'text-slate-600 hover:bg-slate-100'
                    }`}
                    onClick={() => setActiveTab('whatsapp')}
                  >
                    WhatsApp
                  </Link>
                                    <Link
                    to="/perfil-empresa"
                    data-testid="nav-perfil"
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      activeTab === 'perfil'
                        ? 'bg-emerald-50 text-emerald-700'
                        : 'text-slate-600 hover:bg-slate-100'
                    }`}
                    onClick={() => setActiveTab('perfil')}
                  >
                    Mi Empresa
                  </Link>

                  {/* Enlace de Admin - Solo visible para admins */}
                  {user?.rol === 'admin' && (
                    <Link
                      to="/admin"
                      data-testid="nav-admin"
                      className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                        activeTab === 'admin'
                          ? 'bg-amber-50 text-amber-700'
                          : 'text-amber-600 hover:bg-amber-50'
                      }`}
                      onClick={() => setActiveTab('admin')}
                    >
                      🔐 Admin
                    </Link>
                  )}

                  <button
                    onClick={logout}
                    className="ml-4 px-4 py-2 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 transition-all"
                    data-testid="btn-logout"
                  >
                    Salir
                  </button>
                </nav>

                {/* Botón menú móvil */}
                <button
                  className="md:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  data-testid="btn-mobile-menu"
                >
                  {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
              </div>

              {/* Menú móvil desplegable */}
              {mobileMenuOpen && (
                <nav className="md:hidden py-4 border-t border-slate-200 space-y-1" data-testid="mobile-nav">
                  <Link
                    to="/dashboard"
                    className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                      activeTab === 'dashboard' ? 'bg-emerald-50 text-emerald-700' : 'text-slate-600'
                    }`}
                    onClick={() => { setActiveTab('dashboard'); setMobileMenuOpen(false); }}
                  >
                    📊 Dashboard
                  </Link>
                  <Link
                    to="/cotizaciones"
                    className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                      activeTab === 'cotizaciones' ? 'bg-emerald-50 text-emerald-700' : 'text-slate-600'
                    }`}
                    onClick={() => { setActiveTab('cotizaciones'); setMobileMenuOpen(false); }}
                  >
                    📄 Cotizaciones
                  </Link>
                  <Link
                    to="/productos"
                    className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                      activeTab === 'productos' ? 'bg-emerald-50 text-emerald-700' : 'text-slate-600'
                    }`}
                    onClick={() => { setActiveTab('productos'); setMobileMenuOpen(false); }}
                  >
                    📦 Productos
                  </Link>
                  <Link
                    to="/configuracion-whatsapp"
                    className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                      activeTab === 'whatsapp' ? 'bg-emerald-50 text-emerald-700' : 'text-slate-600'
                    }`}
                    onClick={() => { setActiveTab('whatsapp'); setMobileMenuOpen(false); }}
                  >
                    💬 WhatsApp
                  </Link>
                  <Link
                    to="/config-cobros"
                    className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                      activeTab === 'cobros' ? 'bg-amber-50 text-amber-700' : 'text-slate-600'
                    }`}
                    onClick={() => { setActiveTab('cobros'); setMobileMenuOpen(false); }}
                  >
                    💰 Cobros
                  </Link>
                  <Link
                    to="/perfil-empresa"
                    className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                      activeTab === 'perfil' ? 'bg-emerald-50 text-emerald-700' : 'text-slate-600'
                    }`}
                    onClick={() => { setActiveTab('perfil'); setMobileMenuOpen(false); }}
                  >
                    🏢 Mi Empresa
                  </Link>
                  
                  {user?.rol === 'admin' && (
                    <Link
                      to="/admin"
                      className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                        activeTab === 'admin' ? 'bg-amber-50 text-amber-700' : 'text-amber-600'
                      }`}
                      onClick={() => { setActiveTab('admin'); setMobileMenuOpen(false); }}
                    >
                      🔐 Admin
                    </Link>
                  )}
                  
                  <button
                    onClick={() => { logout(); setMobileMenuOpen(false); }}
                    className="w-full text-left px-4 py-3 rounded-lg text-sm font-medium text-red-600"
                  >
                    🚪 Salir
                  </button>
                </nav>
              )}
            </div>
          </header>
        )}

        {/* Main Content */}
        <main className={isAuthenticated && !isOnboarding ? "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" : ""}>
          <Routes>
            {/* Rutas p\u00fablicas */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/login" element={<Login />} />
            <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
            <Route path="/restablecer-contrasena" element={<RestablecerContrasena />} />
            <Route path="/precios" element={<Precios />} />
            <Route path="/pago-exitoso" element={<PagoExitoso />} />
            <Route path="/portal/cotizacion/:token" element={<PortalCliente />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            {/* Rutas SEO */}
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/ferreterias" element={<FerreteriasSEO />} />
            <Route path="/refaccionarias" element={<RefaccionariasSEO />} />
            <Route path="/servicios-tecnicos" element={<ServiciosTecnicosSEO />} />
            <Route path="/privacidad" element={<PrivacidadPage />} />
            <Route path="/terminos" element={<TerminosPage />} />
            <Route path="/calculadoras" element={<Calculadoras />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/afiliados" element={<Afiliados />} />
            <Route path="/calculadora-iva" element={<CalculadoraIVA />} />
            <Route path="/plantillas/cotizacion" element={<PlantillasCotizacion />} />
            <Route path="/generador-de-cotizaciones" element={<GeneradorCotizaciones />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:postSlug" element={<BlogPost />} />
            <Route path="/materiales-construccion" element={<GiroSEO slug="materiales-construccion" />} />
            <Route path="/plomerias" element={<GiroSEO slug="plomerias" />} />
            <Route path="/material-electrico" element={<GiroSEO slug="material-electrico" />} />
            <Route path="/pinturas" element={<GiroSEO slug="pinturas" />} />
            <Route path="/herrerias" element={<GiroSEO slug="herrerias" />} />
            <Route path="/distribuidoras" element={<GiroSEO slug="distribuidoras" />} />
            <Route path="/muebleria" element={<GiroSEO slug="muebleria" />} />
            <Route path="/papelerias" element={<GiroSEO slug="papelerias" />} />
            <Route path="/abarrotes-mayoreo" element={<GiroSEO slug="abarrotes-mayoreo" />} />
            <Route path="/tablaroca-plafones" element={<GiroSEO slug="tablaroca-plafones" />} />
            <Route path="/cancelerias" element={<GiroSEO slug="cancelerias" />} />
            <Route path="/imprentas" element={<GiroSEO slug="imprentas" />} />
            <Route path="/climas" element={<GiroSEO slug="climas" />} />
            <Route path="/cotizacion-formal" element={<CotizacionFormal />} />
            <Route path="/cotizador-para-contratistas" element={<CotizadorOficio slug="cotizador-para-contratistas" />} />
            <Route path="/cotizador-para-techadores" element={<CotizadorOficio slug="cotizador-para-techadores" />} />
            <Route path="/cotizador-para-pintores" element={<CotizadorOficio slug="cotizador-para-pintores" />} />
            <Route path="/usa" element={<LandingUSA />} />
            <Route path="/mensajes-para-clientes-whatsapp" element={<MensajesWhatsApp slug="mensajes-para-clientes-whatsapp" />} />
            <Route path="/mensajes-para-recuperar-clientes-whatsapp" element={<MensajesWhatsApp slug="mensajes-para-recuperar-clientes-whatsapp" />} />
            <Route path="/mensajes-de-seguimiento-a-clientes-whatsapp" element={<MensajesWhatsApp slug="mensajes-de-seguimiento-a-clientes-whatsapp" />} />
            <Route path="/saludos-para-clientes-whatsapp" element={<MensajesWhatsApp slug="saludos-para-clientes-whatsapp" />} />
            <Route path="/cuanto-cobrar-por-pintar" element={<CuantoCobrar slug="cuanto-cobrar-por-pintar" />} />
            <Route path="/cuanto-cobrar-por-drywall" element={<CuantoCobrar slug="cuanto-cobrar-por-drywall" />} />
            <Route path="/cuanto-cobrar-por-instalar-piso" element={<CuantoCobrar slug="cuanto-cobrar-por-instalar-piso" />} />
            <Route path="/cuanto-cobrar-por-un-techo" element={<CuantoCobrar slug="cuanto-cobrar-por-un-techo" />} />
            <Route path="/usa/roofing" element={<OficioUSA slug="roofing" />} />
            <Route path="/usa/landscaping" element={<OficioUSA slug="landscaping" />} />
            <Route path="/usa/painting" element={<OficioUSA slug="painting" />} />
            <Route path="/usa/remodeling" element={<OficioUSA slug="remodeling" />} />
            <Route path="/usa/drywall" element={<OficioUSA slug="drywall" />} />
            <Route path="/usa/handyman" element={<OficioUSA slug="handyman" />} />
            <Route path="/usa/flooring" element={<OficioUSA slug="flooring" />} />
            <Route path="/usa/cleaning" element={<OficioUSA slug="cleaning" />} />
            <Route path="/usa/concrete" element={<OficioUSA slug="concrete" />} />
            <Route path="/usa/fencing" element={<OficioUSA slug="fencing" />} />
            <Route path="/usa/plumbing" element={<OficioUSA slug="plumbing" />} />
            <Route path="/usa/electrical" element={<OficioUSA slug="electrical" />} />
            <Route path="/usa/hvac" element={<OficioUSA slug="hvac" />} />
            <Route path="/usa/tile" element={<OficioUSA slug="tile" />} />
            <Route path="/usa/carpentry" element={<OficioUSA slug="carpentry" />} />
            <Route path="/usa/pressure-washing" element={<OficioUSA slug="pressure-washing" />} />

            {/* Rutas protegidas */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cotizaciones"
              element={
                <ProtectedRoute>
                  <Cotizaciones />
                </ProtectedRoute>
              }
            />
            <Route
              path="/productos"
              element={
                <ProtectedRoute>
                  <Productos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/carga-productos"
              element={
                <ProtectedRoute>
                  <CargaProductos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientes"
              element={
                <ProtectedRoute>
                  <Clientes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/conversaciones"
              element={
                <ProtectedRoute>
                  <Conversaciones />
                </ProtectedRoute>
              }
            />
            <Route
              path="/simulador"
              element={
                <ProtectedRoute>
                  <Simulador />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cotizador"
              element={
                <ProtectedRoute>
                  <Cotizador />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configuracion-whatsapp"
              element={
                <ProtectedRoute>
                  <ConfiguracionWhatsApp />
                </ProtectedRoute>
              }
            />
            <Route
              path="/config-cobros"
              element={
                <ProtectedRoute>
                  <ConfigCobros />
                </ProtectedRoute>
              }
            />
            <Route
              path="/perfil-empresa"
              element={
                <ProtectedRoute>
                  <PerfilEmpresa />
                </ProtectedRoute>
              }
            />
            
            {/* Rutas de Admin */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/promo-codes"
              element={
                <ProtectedRoute>
                  <AdminPromoCodes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/twilio"
              element={
                <ProtectedRoute>
                  <AdminTwilio />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/search"
              element={
                <ProtectedRoute>
                  <AdminSearchStats />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/seo"
              element={
                <ProtectedRoute>
                  <AdminSEO />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            <AppRoutes />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
